import { Component, OnInit } from '@angular/core';
import { WebsocketService } from '../../../services/websocket/websocket.service';
import { EVENTS } from '../../../services/websocket/events';
import { SnotifyService } from 'ng-snotify';
import { LeituraService } from '../../../services/notificacao/leitura.service';
import { EmpresaService } from '../../../services/empresa/empresa.service';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {StatusLeituraPipe} from '../../../pipes/status-leitura.pipe';

@Component({
    selector: 'app-monitor-list-erro',
    templateUrl: './monitor-erro.component.html',
    styleUrls: ['./monitor-erro.component.scss'],
})
export class MonitorErroComponent implements OnInit {

    public loading = false;

    public filter: FormGroup;

    constructor(
        private websocket: WebsocketService,
        private _notify: SnotifyService,
        private leituraService: LeituraService,
        private empresaService: EmpresaService,
        private fb: FormBuilder
    ) {
    }

    public listaArquivos: Array<any> = [];

    public listaGrupos: Array<any> = [];

    public lastResponse = null;

    public currentPage = 1;

    public perPage: string|number = 10;

    public empresas: Array<any> = [];

    public status: Array<any> = [];

    public prioridades: Array<any> = [
        { id: [1, 2, 3, 4, 5], descricao: 'PDFs COM PRIORIDADE'},
    ];

    public loadChangeStatus = {};

    public dropdownSettingsEmpresas = {
        singleSelection: false,
        idField: 'id_empresa',
        textField: 'descricao',
        itemsShowLimit: 5,
        selectAllText: 'Marcar todas',
        unSelectAllText: 'Desmarcar todas',
        allowSearchFilter: true
    };

    public dropdownSettingsStatus = {
        singleSelection: false,
        idField: 'status',
        textField: 'descricao',
        itemsShowLimit: 5,
        selectAllText: 'Marcar todas',
        unSelectAllText: 'Desmarcar todas',
        allowSearchFilter: true
    };

    public dropdownSettingsGrupos = {
        singleSelection: false,
        idField: 'id',
        textField: 'descricao',
        itemsShowLimit: 10,
        selectAllText: 'Marcar todos',
        unSelectAllText: 'Desmarcar todos',
        allowSearchFilter: true
    };

    public dropdownSettingsPrioridade = {
        singleSelection: true,
        idField: 'id',
        textField: 'descricao',
        itemsShowLimit: 10,
        selectAllText: 'Marcar todos',
        unSelectAllText: 'Desmarcar todos',
        allowSearchFilter: false
    };


    ngOnInit() {
        this._setStatus();
        this._initFilters();
        this._listarEmpresas();
        this._listenEvents();
    }

    private _loadArquivos(page: string|number = 1): void {
        this.loading = true;
        this.leituraService.listar(this.getFilters(), page, this.perPage).subscribe(
            (response) => {
                this.loading = false;
                this.lastResponse = response.data;
                this.listaArquivos = this.listaArquivos.concat(response.data.pdfs.data);
            },
            error => {
                this._notify.error('Ocorreu um erro ao listar dados');
                this.loading = false;
            }
        );
    }

    /**
     *
     * private
     */
    private _addArquivo(data): void {
        this.listaArquivos.push(data);
    }

    private _listenEvents(): void {
        this.websocket.listen('notification', EVENTS.errors.leitura.pdf, ({data}) => {
            this._addArquivo(data);
            this._notify.warning('Novo erro encontrado!');
        });
    }

    public loadMore(): void {
        this.currentPage++;
        this._loadArquivos(this.currentPage);
    }

    public loadPerPage($event) {
        this.perPage = $event.target.value;
        this.reset(false);
        this._loadArquivos();
    }

    public reset(reload: boolean): void {
        this.listaArquivos = [];
        this.currentPage = 1;

        if (reload) {
            Object.keys(this.filter.controls).forEach(key => {
                this.filter.controls[key].setValue('');
            });

            this._loadArquivos();
        }
    }

    openPDF(id_pdf_email) {
        this.leituraService.getArquivoEmail(id_pdf_email)
            .subscribe(
                ({data}) => {
                    let blob = null;
                    if (data.tipo_arquivo === 'pdf') {
                        blob = this.convertBase64PdfToBlob(data.arquivo);
                    } else {
                        blob = new Blob([data.arquivo], {'type': `application/${data.tipo_arquivo}`});
                    }
                    const element = document.createElement('a');
                    element.setAttribute('href', URL.createObjectURL(blob));
                    element.setAttribute('download', data.pdf_email.nome_arquivo);
                    element.style.display = 'none';
                    document.body.appendChild(element);
                    element.click();
                },
                error => {
                    this._notify.error('Ocorreu um erro ao baixar PDF');
                }
            );
    }

    private convertBase64PdfToBlob(base64str): Blob {
        // decode base64 string, remove space for IE compatibility
        const binary = atob(base64str.replace(/\s/g, ''));
        const len = binary.length;
        const buffer = new ArrayBuffer(len);
        const view = new Uint8Array(buffer);
        for (let i = 0; i < len; i++) {
            view[i] = binary.charCodeAt(i);
        }
        // create the blob object with content-type "application/pdf"
        return new Blob( [view], { type: 'application/pdf' });
    }

    private _listarEmpresas(): void  {
        this.empresaService.listar(null, '', 'todos')
            .subscribe(
                ({data}) => {
                    this.empresas = data.empresas.map(empresa => {
                        return {
                            id_empresa: empresa.id_empresa,
                            descricao: `${empresa.apelido} - ${empresa.cpf_cnpj}`
                        };
                    });
                },
                error => {
                    this._notify.warning('Ocorreu um erro ao carregar empresas');
                }
            );

        this.empresaService.buscarEmpresasVinculadasGrupo().subscribe(({data}) => {
            const grupos = [];
            for (let i = 0; i < data.length; i++) {
                grupos.push({descricao: data[i].nome_grupo, id: data[i].id});
            }
            this.listaGrupos = grupos;
        });
    }

    private _initFilters() {

        this.filter = this.fb.group({
            prioridades: new FormControl('', []),
            empresa_id: new FormControl('', []),
            grupo_id: new FormControl('', []),
            status: new FormControl([], []),
            recebido_em_ini: new FormControl('', []),
            recebido_em_fim: new FormControl('', []),
            id_pdf_email: new FormControl('', []),
            nome_pdf_email: new FormControl('', [])
        });
    }

    public toFilter() {
        this.reset(false);
        this._loadArquivos();
    }

    public getFilters() {
        const filter = {};

        Object.keys(this.filter.controls).forEach((_filter) => {
            filter[_filter] = this.filter.controls[_filter].value;
        });


        if (filter['empresa_id']) {
            filter['empresa_id'] = filter['empresa_id'].map(empresa => {
                return empresa.id_empresa;
            });
        }

        if (filter['grupo_id']) {
            filter['grupo_id'] = filter['grupo_id'].map(grupo => {
                return grupo.id;
            });
        }

        if (filter['status']) {
            filter['status'] = filter['status'].map(status => {
                return status.status;
            });
        }
        if (filter['id_pdf_email']) {
            filter['id_pdf_email'] = filter['id_pdf_email'].split(',');
        }

        if (filter['prioridades'][0]) {
            filter['prioridades'] = filter['prioridades'][0].id.map(prioridade => {
                return prioridade;
            });
        }
        return filter;
    }

    updateStatusArquivo(idPdf, event) {
        const status = event.target.value;
        this.loadChangeStatus[idPdf] = true;
        this.leituraService.updateArquivo(idPdf, {
            status: status
        }).subscribe(
            response => {
                this._notify.info('Status atualizado com sucesso!');
                this.loadChangeStatus[idPdf] = false;
            },
            error => {
                this._notify.error('Ocorreu um erro ao atualizar status do PDF');
                this.loadChangeStatus[idPdf] = false;
            }
        );
    }

    arquivosPrioridadeBgColor(dataPrioridade): String {
        return dataPrioridade != null ? '#b9edb8' : 'none';
    }

    private _setStatus(): void {
        const status: Object = (new StatusLeituraPipe).getStatus();
        this.status = Object.keys(status).map(_status => {
            return {status: _status, descricao: status[_status]};
        });
    }
}
